import { SoundSpriteDefinitions } from "howler";

export const soundSprites: SoundSpriteDefinitions = {
    "achievement-notification": [
        0,
        2394.5578231292516
    ],
    "answer-button-out": [
        4000,
        87.43764172335577
    ],
    "answer-select": [
        6000,
        789.4784580498869
    ],
    "bonus-fail": [
        8000,
        522.448979591836
    ],
    "bonus-use": [
        10000,
        1471.5646258503393
    ],
    "bonus-win": [
        13000,
        995.5555555555549
    ],
    "button-click": [
        15000,
        53.87755102040792
    ],
    "card-deal1": [
        17000,
        365.7142857142866
    ],
    "card-deal2": [
        19000,
        252.51700680271938
    ],
    "cards-shuffle": [
        21000,
        465.8503401360541
    ],
    "chest-drop": [
        23000,
        202.4943310657612
    ],
    "chest-open": [
        25000,
        790.9297052154187
    ],
    "coins-earned": [
        27000,
        573.2426303854866
    ],
    "correct-answer": [
        29000,
        1969.4784580498847
    ],
    "daily-bonus-item-appear": [
        32000,
        679.2063492063462
    ],
    "dialog-swoosh": [
        34000,
        172.40362811791243
    ],
    "firework": [
        36000,
        699.0249433106542
    ],
    "heart-crack": [
        38000,
        172.69841269840924
    ],
    "hint-award": [
        40000,
        791.4285714285683
    ],
    "incorrect-answer": [
        42000,
        2884.285714285717
    ],
    "level-complete": [
        46000,
        2310.385487528343
    ],
    "level-item-flip": [
        50000,
        222.78911564625759
    ],
    "level-item-select": [
        52000,
        773.9455782312916
    ],
    "level-select": [
        54000,
        2821.2244897959167
    ],
    "life-gained": [
        58000,
        1590.5668934240396
    ],
    "minigame-card-flip": [
        61000,
        208.9795918367372
    ],
    "mouth-pop": [
        63000,
        44.62585034013955
    ],
    "no-lives-left": [
        65000,
        287.34693877551365
    ],
    "not-enough-coins": [
        67000,
        199.54648526076824
    ],
    "panel-swoosh": [
        69000,
        322.92517006803223
    ],
    "question-select": [
        71000,
        62.76643990929642
    ],
    "reveal-map-cards-flip": [
        73000,
        545.6462585033961
    ],
    "score-fly-in": [
        75000,
        70.02267573696486
    ],
    "stars-spew": [
        77000,
        520.2947845804999
    ],
    "swoosh-in": [
        79000,
        135.44217687075388
    ],
    "tile-set-in": [
        81000,
        183.99092970521735
    ],
    "time-warning": [
        83000,
        799.7732426303799
    ],
    "unavailable-level-item-click": [
        85000,
        197.39229024943938
    ],
    "item-purchase": [
        87000,
        735.4875283446773
    ]
};